module.exports = __webpack_public_path__ + "static/media/Denny.addc1cba.jpg";